import { render, staticRenderFns } from "./CRangePicker.vue?vue&type=template&id=37397c04&scoped=true"
import script from "./CRangePicker.vue?vue&type=script&lang=js"
export * from "./CRangePicker.vue?vue&type=script&lang=js"
import style0 from "./CRangePicker.vue?vue&type=style&index=0&id=37397c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37397c04",
  null
  
)

export default component.exports